import React from 'react';
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Theme } from '@simplybenefits/sb-ui-library';
import store from '../../redux/store.js';

/**
 *
 * @param {*} props
 */
const Dial = (props) => {
    const { children, percentage } = props;
    const whitelabel = store.getState().whitelabel;

    return (
        <React.Fragment>
            <div style={{ position: "absolute" }}>
                <CircularProgressbar
                    value={ percentage }
                    styles={{
                        path: {
                            // Path color
                            stroke: whitelabel.primaryColor || Theme.colors.skyBlue
                        },
                        trail: {
                            stroke: Theme.colors.lightGrey
                        }
                    }}
                />
            </div>
            <div
                style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                { children }
            </div>
        </React.Fragment>
    );
};

export default Dial;